import { useMediaQuery } from "@react-hookz/web";
import { primaryInput } from "detect-it";
import { useEffect, useState } from "react";
import { useIsClient } from "usehooks-ts";

/*
 * We don't have a useIsMobile hook since we go with the mobile-first approach
 * and the SSR will render the mobile version first (useMediaQuery is always false on the server side)
 */

/**
 * Screen is tablet or larger
 */
export const useIsTablet = () => useIsMinWidth(768);

/**
 * Screen is desktop or larger
 */
export const useIsDesktop = () => useIsMinWidth(991);

/**
 * Screen is larger than width in pixels
 * @param width - Width in pixels
 **/
export const useIsMinWidth = (width: number) =>
	useMediaQuery(`(min-width: ${width}px)`, {
		initializeWithValue: false,
	});

/**
 * Screen is larger than height in pixels
 * @param width - Height in pixels
 **/
export const useIsMinHeight = (width: number) =>
	useMediaQuery(`(min-height: ${width}px)`, {
		initializeWithValue: false,
	});

export const useHasMousePointer = () => {
	const [hasMouse, setHasMouse] = useState(false);
	const isClient = useIsClient();

	useEffect(() => {
		if (isClient) {
			setHasMouse(primaryInput === "mouse");
		}
	}, [isClient]);

	return hasMouse;
};
